import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const applyDefaultFilterByRequestId = (crud: Crud, requestId: number) => {
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'RequestId',
        operator: Operator.EQUAL,
        value: requestId,
      },
    ],
  })
}
